<div class="row-container">
  <div
    class="left-bar"
    [class.selectable]="selectable"
    [class.selected]="selectable && selected"
    [class]="selectable ? '' : color"
  >
    <ion-checkbox
      *ngIf="selectable"
      [checked]="selected"
      mode="ios"
      data-cy="row-checkbox"
      (ionChange)="checkboxChange.emit($event)"
    ></ion-checkbox>
  </div>

  <ion-row
    class="row"
    data-cy="row-card"
    (click)="cardClick.emit()"
    [class.selected]="selectable && selected"
  >
    <ion-col size="12">
      <ion-row class="row-card-title" data-cy="row-card-title">
        <ion-col
          *ngIf="customerName || customerNumber"
          class="row-card-customer-name"
          size-xs="12"
          size-sm="12"
          size-md="6"
        >
          <p>
            <strong data-cy="row-card-customer-name">
              {{ customerName | titlecase }}
            </strong>
          </p>
          <span data-cy="row-card-customer-number">({{ customerNumber }})</span>
        </ion-col>
        <ion-col
          *ngIf="edgeAction"
          size-xs="12"
          size-sm="12"
          size-md="6"
          class="action-row"
          data-cy="row-card-edge-action"
        >
          <strong (click)="edgeActionClick.emit()">
            {{ edgeAction }}
          </strong>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="status || subtitle" class="container-status">
        <p
          *ngIf="status"
          class="status"
          [class]="color"
          data-cy="row-card-status"
        >
          <span
            *ngIf="showColorCircle"
            class="status-circle"
            [class]="color"
          ></span>
          {{ status }}
        </p>
        <p class="subtitle" data-cy="row-card-subtitle">
          {{ subtitle }}
        </p>
      </ion-row>

      <ion-row class="additional-info" data-cy="row-card-additional-info">
        {{ additionalInfo }}
        <a
          [class.plain-text]="!hasLink"
          (click)="!!hasLink && linkClick.emit()"
          href="javascript:void(0)"
          data-cy="row-card-link"
        >
          &nbsp;{{ linkText }}
        </a>
      </ion-row>
    </ion-col>

    <ng-container *ngFor="let column of columnsData; let i = index">
      <ion-col
        class="row-card-column"
        *ngIf="column.length > 0"
        [class.row-card-column-last]="i === columnCount - 1"
        [size]="columnSize"
        [attr.data-cy]="'row-card-column-' + i"
      >
        <div>
          <p
            *ngFor="let data of column; let j = index"
            [attr.data-cy]="'row-card-column-' + i + '-' + j"
          >
            {{ data.text }}
            {{ data.value }}
          </p>
        </div>
      </ion-col>
    </ng-container>

    <ion-col class="row-icon" *ngIf="icon" data-cy="row-icon">
      <ion-icon [name]="icon" (click)="iconClick.emit()"></ion-icon>
    </ion-col>
  </ion-row>
</div>
